import { render, staticRenderFns } from "./PageNavigation.vue?vue&type=template&id=8dbf2a02&scoped=true&"
import script from "./PageNavigation.vue?vue&type=script&lang=js&"
export * from "./PageNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PageNavigation.vue?vue&type=style&index=0&id=8dbf2a02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbf2a02",
  null
  
)

export default component.exports